module.exports = __webpack_public_path__ + "static/media/results.15e2e4b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/results.png
// module id = 365
// module chunks = 0